// removed by extract-text-webpack-plugin
module.exports = {"hamburger":"_54_2-oIHlFupEk7_i067N","open":"_1Okkud6aaHk3aLu9us22yS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/hamburger/Hamburger.css
// module id = 326
// module chunks = 0